import { DeleteModalComponent } from './../../components/delete-modal/delete-modal';
import { LoginService } from './../../services/login.service';
import { UsuarioApi } from './../../services/lbsdk/services/custom/Usuario';
import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ModalController, LoadingController } from 'ionic-angular';
import { AltaUsuarioPage } from '../alta-usuario/alta-usuario';
import { ConsultasSqlApi, RolApi, SucursalApi, User, UsuarioSucursal } from '../../services/lbsdk';
import { AuthService } from '../../services/auth/auth.service';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { UsuarioSucursalProvider } from '../../providers/users/companies.provider';


/**
 * Generated class for the UsersPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-users',
  templateUrl: 'users.html',
})
export class UsersPage {
  sucursales = [];
  pagina: number = 0;
  apellidoFiltro: string = "";
  nombreFiltro: string = "";
  emailFiltro: string = "";


  user: User[] = [];
  users: any[] = [];
  roles: any = [];
  admin;
  superAdmin;
  paginationInfo = {
    page: 0,
    pageSize: 0,
    rowCount: 0,
    pageCount: 0
  }
  idsucursal: String[] = [];;
  idusuarios: Number[] = [];;
  sortReverse: boolean = false;
  sortField: string = 'nombre';
  sortType: string = 'ASC';
  searchKey: string = '';
  sucursalSeleccionada;
  private subject: Subject<string> = new Subject<string>();

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private _us: UsuarioApi,
    private usuarioSucursalProvider: UsuarioSucursalProvider,
    private _ls: LoginService,
    public modalCtrl: ModalController, public rolApi: RolApi, private authService: AuthService,
    private loading: LoadingController, private consultaSql: ConsultasSqlApi, private sucursalApi: SucursalApi
  ) {
    //TODO this.sucursalSeleccionada = this.authService.userData.sucursales[0]
  }

  cargarUsuarios() {
    this.consultaSql.GetStoreDinamic({
      nombreStore: "GetUsuarioPaginador",
      data: {
        EMAIL: this.emailFiltro,
        NOMBRE: this.nombreFiltro,
        APELLIDO: this.apellidoFiltro,
        IDSUCURSAL: this.sucursalSeleccionada ? this.sucursalSeleccionada.idsucursal : 0,
        IDUSUARIO: this.authService.userData.user.idusuario,
        PAGESIZE: 6,
        PAGENUMBER: this.pagina

      }
    }).flatMap(respuesta => {
      console.log(respuesta)
      let dataPaginador = respuesta[0]
      this.paginationInfo.rowCount = dataPaginador.total; //ESTA BIEN
      this.paginationInfo.pageCount = dataPaginador.total_pages + 1;
      this.paginationInfo.pageSize = 6;
      this.paginationInfo.page = this.pagina + 1
      console.log("***** PAGINADOR ", this.paginationInfo)
      return this.consultaSql.GetStoreDinamic({
        nombreStore: "GetUsuarioPaginadorDatos",
        data: {
          EMAIL: this.emailFiltro,
          NOMBRE: this.nombreFiltro,
          APELLIDO: this.apellidoFiltro,
          IDSUCURSAL: this.sucursalSeleccionada ? this.sucursalSeleccionada.idsucursal : 0,
          IDUSUARIO: this.authService.userData.user.idusuario,
          PAGESIZE: 6,
          PAGENUMBER: this.pagina

        }
      })
    }).subscribe(respuesta => {
      this.users = respuesta;
    });
  }
  ionViewDidEnter() {

    this.filtrarSucursales()
    // this.cargarUsuarios();


  }
  cambioSucursal(event) {
    this.pagina = 0
    this.cargarUsuarios();
  }
  compareWith(o1, o2) {

    return o1 && o2 ? o1.id === o2.id : o1 === o2;


  }
  ionViewDidLoad() {
    // Muestra botones de editar o agregar usuarios si es admin o superadmin
    this.superAdmin = this.authService.isSuperAdministrador();
    this.admin = this.authService.isAdministrador();
  }


  SetRolesAndUsers(): any {

  }





  addNew() {
    this.navCtrl.push(AltaUsuarioPage)
  }

  update(user: any) {
    console.log("DATOS QUE ENVIA ", user, " otro ", user.Company)
    this.navCtrl.push(AltaUsuarioPage, { data: user, empresas: user.Company/*, roles: user.UsuarioRol*/ });
  }

  cnangePassword(user: any) {
    this.navCtrl.push(AltaUsuarioPage, { data: user, empresas: user.Company, soloPassword: true });
  }

  Delete(user: any) {
    let modal = this.modalCtrl.create(DeleteModalComponent, { data: user });
    modal.present();

    modal.onDidDismiss(res => {
      if (res == false) return;
      this._us.deleteById(user.id).subscribe(res => {
        console.log("res delete", res);
        this.SetRolesAndUsers();
      }, err => console.log("ErrDelete", err));
    });
  }
  onKeyUp(event) {
    this.cargarUsuarios();

  }

  changePage(valor, tipo) {

    if (tipo == "siguiente") {
      this.pagina += 1;
    }
    else if (tipo == "atras") {
      this.pagina -= 1;
    }
    // this.pagina = valor;
    // alert("VALOR PAGINA " + valor)
    this.cargarUsuarios()
  }

  filtrarSucursales() {
    this.sucursales = [];
    console.log("ADMINISTRADOR ", this.authService.isAdministrador())
    if (!this.authService.isSuperAdministrador()) { //(this.authService.userData.user.gerencia == false) {
      this.sucursales = this.authService.userData.sucursales.filter(x => x.idempresa == this.authService.empresaSeleccionada)//this.empresa.idEmpresa);
      if (this.sucursales.length > 0) {
        this.sucursalSeleccionada = this.sucursales[0]
      }
      this.cargarUsuarios();

    }
    //if (this.sucursales.length > 0) {
    else {
      console.log("EMPRESA ID ")
      //ANTES FILTRABA POR EMPRESA AHORA TRAIGO TODAS LAS SUCURSALES
      /*   this.sucursalApi.find({
           where:
             { idempresa: this.authService.empresaSeleccionada }//this.empresa.idEmpresa }*/
      this.sucursalApi.find()
        .subscribe(respuesta => {
          respuesta.push({idsucursal: 0, nombre: "Todas"})
          this.sucursales = respuesta;
          
          if (respuesta.length > 0) {
            console.log("SELECCIONA", this.sucursales[0])
            this.sucursalSeleccionada = this.sucursales[ this.sucursales.length - 1]
          }
          this.cargarUsuarios();
          //   this.sucursales.push({ idsucursal: 0, nombre: "Todas" });
          //this.sucursalSeleccionada = { idsucursal: 0, nombre: "Todas" }
          // alert(JSON.stringify(this.sucursales))
        })
    }
    // this.sucursales = this.sucursales.filter(x => x.idempresa == this.empresa.idEmpresa);

    //}






  }
  cambioEmpresa(event) {
    this.ionViewDidEnter()
  }
}

export class paginationInfo {
  page: number;
  pageSize: number;
  rowCount: number;
  pageCount: number;
}




// WEBPACK FOOTER //
// ./src/pages/users/users.ts